import React, { useState, useEffect } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import WalletCard from "../../components/RetailerBusinessAgent/WallertCard1";
import { API_URL } from "../../constant";
import wallet1 from "../../images/shapes/Wallet01 5.png";
import wallet2 from "../../images/shapes/Wallet03.1 1.png";
import dollarG from "../../images/shapes/Dollar Bag.png";
import dollarY from "../../images/shapes/Dollar Bag (1).png";
import history1 from "../../images/shapes/Group 37483.png";

const Dashboard = () => {
  const navigate = useNavigate();
  const { userData } = useOutletContext();
  const [promotionalWallet, setPromotionalWallet] = useState(null);
  const [collectibleWallet, setCollectibleWallet] = useState(null);
  const [loading, setLoading] = useState(true);
  const [containerStyle, setContainerStyle] = useState({});

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const token = localStorage.getItem("account_admin_token");
        
        const [promoRes, collectRes] = await Promise.all([
          fetch(`${API_URL}/api/account-admin/wallets/promotional-summary`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
          }),
          fetch(`${API_URL}/api/account-admin/wallets/collectible-summary`, {
            headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
          })
        ]);

        if (promoRes.ok) setPromotionalWallet(await promoRes.json());
        if (collectRes.ok) setCollectibleWallet(await collectRes.json());
      } catch (err) {
        console.error("Failed to load dashboard data");
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ ...containerStyle, height: "auto" }}>
  

      <div className="wallet-container1">
        {/* Captain TC Promotional Cash Wallet (14) */}
        <WalletCard
          imgH={wallet2}
          imgT={dollarG}
          imgHi={history1}
          title="Captain TC Promotional Cash Wallet"
          amount={`£${(promotionalWallet?.total_bonus_card_balance*0.005 || 0).toFixed(2)}`}
          subText={`Total Value`}
          bgColor="#f0fdf4"
          bgColor1="#dcfce7"
          onHistoryClick={() => navigate("/account-admin/history")}
        />

        {/* CaptainTC CollectibleCards Wallet (15) */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="CaptainTC CollectibleCards Wallet"
          amount={`£${(promotionalWallet?.total_extra_card_balance*0.005 || 0).toFixed(2)}`}
          subText={`Total Value`}
          bgColor="#fffbeb"
          bgColor1="#fef3c7"
          onHistoryClick={() => navigate("/account-admin/history")}
        />

        {/* Issue Cashback / Pending Requests */}
        <WalletCard
          imgH={wallet1}
          imgT={dollarY}
          imgHi={history1}
          title="Issue CashBack Requested"
          amount={`${promotionalWallet?.pending_cashback_requests_count || 0} Requests`}
          subText="Pending Cashback Approvals"
          bgColor="#eff6ff"
          bgColor1="#dbeafe"
          onHistoryClick={() => navigate("/account-admin/requests")}
        />
      </div>
    </div>
  );
};

export default Dashboard;
